(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairPrizesController', VirtualFairPrizesController)

    VirtualFairPrizesController.$inject = ['VirtualFairService', 'expos'];

    function VirtualFairPrizesController(VirtualFairService, expos) {
        var vm = this;
        vm.queryFlag                    = false;
        vm.expos                        = expos;
        vm.expoSelected                 = -1;
        vm.getPrizes                    = getPrizes;
        vm.prizes                       = [];
        vm.referrals                    = [];
        vm.winners                      = [];
        vm.randomBg                     = randomBg;
        vm.showPrize                    = false;
        vm.generateWinners              = generateWinners
        vm.saveWinners                  = saveWinners
        vm.hasDBWinners                 = false;

        function randomBg(){
            const backgrounds = ['emerald-bg', 'red-bg', 'yellow-bg', 'green-bg', 'purple-bg', 'gray-bg']
            return backgrounds[Math.floor(Math.random() * backgrounds.length)]
        }
        function checkShowPrize(){
            if(vm.winners.length) vm.showPrize = true
            if(vm.expoSelected !== -1){
                const expo = vm.expos.find(ex => ex.id === vm.expoSelected);
                if(expo.sessions && expo.sessions.length){
                    expo.sessions.sort((a,b)=> b.id - a.id)
                    const session = expo.sessions[0]
                    vm.showPrize = moment(session.end_datetime_utc).isBefore(moment().utc())
                }
            }
        }
        function saveWinners(){

            const payload = vm.winners.map((w) => ({
                'user_id': w.user_id,
                'expo_virtual_fair_id': vm.expoSelected,
                'prize_id': w.prize_id
            }))
            VirtualFairService.saveWinners(payload).then(function(response){
                vm.hasDBWinners   = true
            })
        }
        function generateWinners(){
            VirtualFairService.generateWinners({expoId: vm.expoSelected}).then(function(response){
                vm.queryFlag    = true;
                vm.winners      = response.data
            })
        }
        function getPrizes () {
            var self = this;
            checkShowPrize()
            VirtualFairService.getPrizes({expoId: vm.expoSelected}).then(function(response){
                vm.queryFlag    = true;
                vm.prizes       = response.data.map(p => ({
                    ...p,
                    bgColor: self.randomBg()
                }));
            })
            VirtualFairService.getReferrals({expoId: vm.expoSelected}).then(function(response){
                vm.referrals = response.data;
            })
            VirtualFairService.getWinners({expoId: vm.expoSelected}).then(function(response){
                vm.winners = response.data;
                if(vm.winners.length) vm.hasDBWinners = true
            })

        }
    }
})();